module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("An Italian-American writer residing between Paris and New York, Sabrina Marzaro has developed her career in the luxury realm, specialising in marketing and communications. Passionate about weaving words and sculpting stories that inspire, she is a copywriter and strategic consultant for prestigious brands such as Guerlain, Clarins and L’Oréal, for whom her work has been published internationally. Her expertise and entrepreneurial ventures led her to become Professor of Creative Strategies at New York’s Fashion Institute of Technology (FIT), as well as to share her knowledge through conferences held for various organisations in the luxury and creative fields.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Brushstrokes")]), _vm._v(" is her second publication, following her first book, "), _c('em', [_vm._v("Swiping for Prince Charming")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0